import * as yup from "yup";

export const createLocationSchema = yup.object().shape({
  location: yup.object({ text: yup.string(), value: yup.string() }).required(),
});
